<template>
    <div style="width: 1200px">
        <comp-title-dc back-url-name="home">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">资产首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="assets-detail">
            <div class="assets-title">
                <span class="fund-name">{{ assetsInfo.fundshortname || assetsInfo.fundname }}</span>
                <span class="fund-code">{{ assetsInfo.fundcode }}</span>
                <span class="fund-detail" v-on:click="gotoDetail">基金详情></span>
            </div>
            <div class="assets-amount">
                <div
                    v-for="(item, index) in profits"
                    :key="index"
                    class="amount-item"
                    :class="index < 2 ? 'right-line' : ''"
                >
                    <div class="amount-label">
                        {{ item.text }}
                        <span v-if="index > 0 && assetsInfo.profitdate" class="time-item">
                            ({{ $util.fmtDate(assetsInfo.profitdate) }})
                        </span>
                    </div>
                    <div class="amount-value" :class="item.class">
                        {{ $util.fmtNum(item.val) }}
                    </div>
                </div>
            </div>
            <el-descriptions class="margin-top" :column="3" size="small" border>
                <el-descriptions-item v-for="(item, index) in info" :key="index">
                    <span slot="label" class="desc-label">{{ item.text }}</span>
                    <span
                        class="font-14"
                        :class="
                            item.type == 'dividend'
                                ? 'dividend-text'
                                : item.class
                                ? item.class
                                : 'desc-content'
                        "
                        v-on:click="goDividend(item.type)"
                    >
                        {{ item.val }}
                    </span>
                    <span v-if="item.days" class="days-text">({{ item.days }}天)</span>
                    <span v-if="item.date">({{ item.date }})</span>
                </el-descriptions-item>
            </el-descriptions>
            <div class="btns">
                <div v-for="(item, index) in btns" :key="index" class="button">
                    <span v-if="index === 0" class="buy-button" v-on:click="dealAssets(index)">
                        {{ item }}
                    </span>
                    <span v-else>
                        <el-tooltip
                            class="item"
                            effect="info"
                            :content="`请下载理财客APP${item}该产品`"
                            placement="top"
                        >
                            <el-button type="text" disabled size="small">{{ item }}</el-button>
                        </el-tooltip>
                    </span>
                </div>
            </div>
        </div>
        <profit-chart
            v-if="assetsInfo"
            :profit-list="profitList"
            :performance-list="performanceList"
        ></profit-chart>
        <div class="assets-data">
            <share-detail
                v-if="assetsInfo"
                :fundshowtype="assetsInfo.fundshowtype"
                :vol-list="assetsInfo.fundArr"
            ></share-detail>
            <profit-detail
                v-if="assetsInfo"
                ref="profitDetail"
                :fundcode="assetsInfo.fundcode"
            ></profit-detail>
            <assets-trade-detail
                v-if="assetsInfo"
                :fundcode="assetsInfo.fundcode"
            ></assets-trade-detail>
        </div>
        <qr-code
            :fundcode="assetsInfo.fundcode"
            :is-public="isPublic"
            :dialog-visible="buyDialogVisible"
            v-on:dialog-close="buyDialogVisible = false"
        ></qr-code>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import differenceInDays from "date-fns/difference_in_days";
import profitChart from "@/components/fund/profitChart.vue";
import shareDetail from "@/components/fund/shareDetail";
import profitDetail from "@/components/fund/profitDetail.vue";
import assetsTradeDetail from "@/components/fund/assetsTradeDetail";
import qrCode from "@/components/fund/qrCodeGuide";
import fundApi from "@/api/fund";
import format from "date-fns/format";

export default {
    name: "AssetsDetail",
    components: {
        profitChart,
        shareDetail,
        profitDetail,
        assetsTradeDetail,
        qrCode
    },
    mixins: [mixin],
    data() {
        return {
            assetsInfo: {}, // 持仓信息
            btns: ["申购", "定投", "赎回"],
            profits: [], // 收益金额
            info: [], // 资产信息
            isPublic: false, // 是否公募
            profitList: [], // 收益列表
            performanceList: [], // 业绩走势列表
            buyDialogVisible: false // 是否展示引导二维码
        };
    },
    mounted() {
        this.assetsInfo = JSON.parse(sessionStorage.getItem("_currentAsset"));
        this.assetsInfo.isChange = this.$util.checkChange(this.assetsInfo);
        this.btns[0] = this.assetsInfo.status == "1" ? "认购" : "申购";
        if (this.assetsInfo.producttype === "1") {
            // 私募产品没有定投
            this.btns.splice(1, 1);
        }
        this.isPwdCheck = this.$cache.getPwdCheck("29");
        this.assignData();
        if (this.assetsInfo.producttype) {
            this.isPublic = this.assetsInfo.producttype == "0";
        } else {
            this.getFundClass();
        }
        this.getProfitList();
        setTimeout(() => {
            this.getPerformanceTrendList();
        }, 100);
    },
    methods: {
        // 赋值收益数据、资产信息
        assignData() {
            this.profits = [
                {
                    text: "金额(元)",
                    val: this.assetsInfo.marketvalue
                },
                {
                    text: "持仓收益(元)",
                    val: this.assetsInfo.currentprofit,
                    class: this.$util.colorClass(this.assetsInfo.currentprofit)
                },
                {
                    text: "累计收益(元)",
                    val: this.assetsInfo.totalprofit,
                    class: this.$util.colorClass(this.assetsInfo.totalprofit)
                }
            ];
            this.info = [
                {
                    text: "最新净值(元)",
                    val: this.$util.fmtNum(this.assetsInfo.nav, 4),
                    date: this.$util.fmtDate(this.assetsInfo.navdate)
                },
                {
                    text: "昨日收益(元)",
                    val: this.$util.fmtNum(this.assetsInfo.lastprofit),
                    class: this.$util.colorClass(this.$util.fmtNum(this.assetsInfo.lastprofit))
                },
                {
                    text: "日涨幅",
                    val: this.assetsInfo.dayfloatprofit
                        ? this.$util.fmtNum(this.assetsInfo.dayfloatprofit) + "%"
                        : "--",
                    class: this.$util.colorClass(this.$util.fmtNum(this.assetsInfo.dayfloatprofit))
                },
                {
                    text: "持有金额(元)",
                    val: this.$util.fmtNum(this.assetsInfo.marketvalue)
                },
                {
                    text: "持仓收益率",
                    val:
                        this.assetsInfo.currentprofitrate || this.assetsInfo.currentprofitrate === 0
                            ? this.$util.fmtNum(this.assetsInfo.currentprofitrate) + "%"
                            : "--",
                    class: this.$util.colorClass(
                        this.$util.fmtNum(this.assetsInfo.currentprofitrate)
                    )
                },
                {
                    type: "dividend",
                    text: "分红方式",
                    val: this.$cache.getDict("110001", this.assetsInfo.dividendmethod) + ">"
                },
                {
                    text: "成本单价(元)",
                    val: this.$util.fmtNum(this.assetsInfo.averagecost, 4)
                },
                {
                    text: "持仓成本(元)",
                    val: this.$util.fmtNum(this.assetsInfo.costmoney)
                },

                {
                    text: "持仓份额(份)",
                    val: this.$util.fmtNum(this.assetsInfo.currentshare)
                }
            ];
            if (this.assetsInfo.fundshowtype == "5") {
                // 货币基金
                this.info[0] = {
                    text: "万份收益(元)",
                    val: this.$util.fmtNum(this.assetsInfo.fundincomeunit, 4),
                    class: this.$util.fmtNum(this.assetsInfo.fundincomeunit, 4) < 0 ? "reduce" : ""
                };
                this.info[2] = {
                    text: "七日年化收益率",
                    val: this.assetsInfo.growthrate ? this.assetsInfo.growthrate + "%" : "--",
                    class: this.assetsInfo.growthrate < 0 ? "reduce" : ""
                };
            }
        },
        // 格式化涨跌幅数据
        formatterRate(rate) {
            if (!rate) {
                return "--";
            }
            return this.$util.fmtNum(rate) + "%";
        },
        // 跳转到基金详情
        gotoDetail() {
            this.$util.toFundDetail(this.assetsInfo.fundcode, this.isPublic);
        },
        // 操作按钮事件
        dealAssets(index) {
            this.buyDialogVisible = true;
            // const array = ["20,22", "59", "24", "36"];
            // let way = array[index];
            // let moduleId = "";
            // let flag = "0";
            // if (way == "20,22") {
            //     if (this.assetsInfo.status == "1") {
            //         moduleId = "20";
            //     } else {
            //         moduleId = "22";
            //     }
            // } else {
            //     moduleId = way;
            // }
            // if (moduleId == "20" || moduleId == "22" || moduleId == "36" || moduleId == "29") {
            //     flag = "0";
            // } else {
            //     flag = "1";
            // }
            // // 申购 22 认购 20  转换36  赎回24  预约赎回25 定投59
            // const _this = this;
            // _this.$util.checkGtOcrModule(moduleId, flag, (res) => {
            //     _this.fundCon(way, this.assetsInfo);
            // });
        },
        // 进一步操作
        fundCon(way, fund) {
            const _this = this;
            if (way === "24") {
                if (fund.isSell) {
                    this.$message.warning(fund.isSell);
                    return;
                }
                const _fund = _this.$util.dataTaacFilter(fund);
                const _x = Object.assign({}, _fund, { way: way });
                sessionStorage.setItem("sellfund", JSON.stringify(_x));
                this.$router.push({ name: "sellfund", query: { fundcode: fund.fundcode } });
            } else if (way === "36") {
                if (this.assetsInfo.isChange) {
                    this.$message.warning(this.assetsInfo.isChange + ",不能转换");
                    return;
                }
                fund.proto = "change";
                this.$util.fundRiskCheck(this, fund, (res) => {
                    if (res) {
                        _this.$util.getSdxProtocol(res, (data) => {
                            if (data) {
                                const _x = Object.assign({}, data, { way: way });
                                sessionStorage.setItem("changefund", JSON.stringify(_x));
                                this.$router.push({
                                    name: "changefund",
                                    query: { fundcode: _x.fundcode }
                                });
                            }
                        });
                    }
                });
            } else {
                let _url = "";
                // 购买
                if (way == "20,22" || way == "59") {
                    // 普通购买
                    if (way == "20,22" && fund.isBuy) {
                        this.$message.warning(fund.isBuy + "，不能申购");
                        return;
                    }
                    if (way == "59" && fund.isCurrency) {
                        this.$message.warning(fund.isCurrency);
                        return;
                    }
                    fund.proto = way == "59" ? "plan" : "buy";
                    this.$util.fundRiskCheck(this, fund, (res) => {
                        if (res) {
                            _this.$util.getSdxProtocol(res, (data) => {
                                if (data) {
                                    const _x = Object.assign({}, data, { way: way });
                                    _url = way == "59" ? "generalbuy" : "buyfund";
                                    sessionStorage.setItem(_url, JSON.stringify(_x));
                                    _this.$router.push({
                                        name: _url,
                                        query: { fundcode: _x.fundcode }
                                    });
                                }
                            });
                        }
                    });
                }
            }
        },
        // 跳转至【基金交易-分红管理】页面
        goDividend(type) {
            if (!type) {
                return;
            }
            this.$router.push({ name: "dividendInfo" });
        },
        // 获取收益走势图，默认一年
        async getProfitList() {
            if (!this.$cache.getBinded()) {
                return;
            }
            const _x = {
                fundcode: this.assetsInfo.fundcode,
                rangetype: "4"
            };
            const res = await fundApi.qryHistoryProfit(_x);
            if (res.data) {
                this.profitList = res.data.data;
            }
            if (this.$refs.profitDetail) {
                this.$refs.profitDetail.getProfitDetail();
            }
        },
        // 获取业绩走势数据
        async getPerformanceTrendList() {
            const _x = {
                CALCULATE_TYPE: "1",
                INDEX_CODE: "000300.SH",
                INTERVAL_VEIDOO: "8",
                FUND_CODE: this.assetsInfo.fundcode
            };
            let res = null;
            if (this.isPublic) {
                res = await fundApi.qryPerformanceTrend(_x);
            } else {
                res = await fundApi.qryPrivatePerformanceTrend(_x);
            }
            if (res.data) {
                this.performanceList = res.data.FUND_CURVES || [];
            }
        },
        // 获取产品类型 公募、私募
        async getFundClass() {
            const res = await fundApi.qryFundClass({
                fundcode: this.assetsInfo.fundcode,
                pagesize: "1",
                pagenum: "1",
                fundclass: "*"
            });
            if (res.data && res.data.list && res.data.list.length) {
                const fund = res.data.list[0];
                this.isPublic = fund.fundclass == "0";
            }
        },
        fmtDateDDMM(profitdate) {
            return format(profitdate, "MM-DD");
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/varibles";
.assets-detail {
    margin-top: 10px;
    margin-bottom: 20px;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    .assets-title {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .fund-name {
            font-size: 20px;
            font-weight: 500;
            color: #333333;
        }
        .fund-code {
            margin-left: 4px;
            font-size: 14px;
            font-weight: bold;
            color: #999999;
        }
        .fund-detail {
            margin-left: 4px;
            font-size: 14px;
            font-weight: normal;
            color: #007cee;
            cursor: pointer;
            margin-left: auto;
        }
    }
    .assets-amount {
        box-sizing: border-box;
        height: 94px;
        border: 1px solid #f1f1f1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 0;
        margin-bottom: 12px;
        .amount-item {
            width: 385px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-left: 24px;
            .amount-label {
                font-size: 14px;
                font-weight: normal;
                line-height: 14px;
                color: #666666;
                margin-bottom: 12px;
            }
            .amount-value {
                font-size: 32px;
                font-weight: 500;
                line-height: 28px;
                color: #333333;
            }
            .add {
                color: $risk5;
            }
            .reduce {
                color: $risk1;
            }
            .time-item {
                font-size: 12px;
                color: $text-color7;
            }
        }
        .right-line {
            border-right: 1px solid #f1f1f1;
        }
    }
    .desc-label {
        font-size: 14px;
        font-weight: normal;
        color: #666666;
    }
    .desc-content {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
    }
    .dividend-text {
        font-size: 14px;
        color: #007cee;
        cursor: pointer;
    }
    .days-text {
        font-size: 14px;
        font-weight: normal;
        line-height: 20px;
        color: #999999;
    }
    .btns {
        margin-top: 20px;
        display: flex;
        gap: 10px;
        .button {
            width: 106px;
            height: 32px;
            border-radius: 2px;
            background: #ffffff;
            box-sizing: border-box;
            border: 1px solid #d9d9d9;
            cursor: pointer;
            font-size: 14px;
            font-weight: normal;
            line-height: 32px;
            text-align: center;
            color: #e60012;
            span {
                display: block;
                .el-button {
                    width: 100%;
                }
            }
        }
        .buy-button {
            color: #ffff;
            background: #e60012;
        }
    }
    .add {
        color: $risk5;
    }
    .reduce {
        color: $risk1;
    }
    .font-14 {
        font-size: 14px;
    }
}
.assets-data {
    margin-bottom: 20px;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
}
</style>
